import { TranslateFn } from 'hooks/useTranslate';

import { SharesTransferExcelValidationError } from '../types/SharesTransferExcel';

export const getSharesTransferExcelValidationMessages = (
  errors: SharesTransferExcelValidationError[],
  t: TranslateFn
): string[] => {
  const messages = errors.map((error) => {
    const baseKey = `SharesTransferExcelError_${error.code}`;
    const params = {
      operationId: error.operationId || '',
      rowIndex: error.rowIndex || '',
      cif: error.cif || '',
      detail: error.detail || '',
    };

    const translated = t(baseKey, params);

    if (translated === baseKey) {
      return `${error.code}${error.operationId ? ` (${error.operationId})` : ''}`;
    }

    return translated;
  });

  return [...new Set(messages)];
};
